import { translate } from "~/plugins/I18n.ts";

const { confirm, error } = useToast();

type Exception = {
	class: string;
	message: string;
};

export async function processRequest(
	request: (submitDataOrId: any, submissionData?: object) => Promise<any>,
	requestData: object,
	confirmFunction: (data?: any) => Promise<void>,
	successFunction?: (data?: any) => void,
	successData?: any,
	requestId?: string,
) {
	if (!("confirmedExceptions" in requestData)) {
		requestData.confirmedExceptions = [];
	}
	const promise = requestId ? request(requestId, requestData) : request(requestData);
	await promise
		.then(() => {
			if (successFunction != null) {
				successFunction(successData);
			}
		})
		.catch((err) => {
			if (err.status == "PRECONDITION_REQUIRED") {
				processConfirmation(err.parameters.errors, requestData, confirmFunction, requestId);
			} else {
				console.log(err);
				const errorMessage = err.message ?? "Er is iets misgegaan";
				error(errorMessage);
			}
		});
}

export async function processConfirmation(
	exceptions: Exception[],
	confirmData: any,
	confirmFunction: (submitDataOrId: any, submissionData?: object) => Promise<void>,
	confirmId?: string,
) {
	const exceptionClasses = exceptions.map((exception) => exception.class);
	const exceptionMessages = exceptions.map((exception) => exception.message);
	const formattedErrorMessage = [...exceptionMessages, "Weet u zeker dat u wilt doorgaan?"].join("<br><br>");
	confirm(formattedErrorMessage, {
		denyButtonText: translate("common.words.no"),
		confirmButtonText: translate("common.words.yes"),
	}).then((result) => {
		if (result.isConfirmed) {
			if (!("confirmedExceptions" in confirmData)) {
				confirmData.confirmedExceptions = [];
			}

			confirmData.confirmedExceptions = confirmData.confirmedExceptions.concat(exceptionClasses);
			if (confirmId) {
				confirmFunction(confirmId, confirmData);
			} else {
				confirmFunction(confirmData);
			}
		}
	});
}
